import { css as d, LitElement as v, html as p } from "lit";
import { property as c, customElement as g } from "lit/decorators.js";
var b = Object.defineProperty, m = Object.getOwnPropertyDescriptor, l = (i, a, s, t) => {
  for (var r = t > 1 ? void 0 : t ? m(a, s) : a, o = i.length - 1, n; o >= 0; o--)
    (n = i[o]) && (r = (t ? n(a, s, r) : n(r)) || r);
  return t && r && b(a, s, r), r;
};
let e = class extends v {
  constructor() {
    super(...arguments), this.variant = "default", this.size = "md";
  }
  render() {
    return p`<span class="badge" part="badge"><slot></slot></span>`;
  }
};
e.styles = d`
    :host {
      display: inline-flex;
      --_bg: var(--kl-badge-bg, var(--kl-surface-muted, #f4f4f5));
      --_color: var(--kl-badge-color, var(--kl-ink-secondary, #3f3f46));
      --_border: var(--kl-border, #e4e4e7);
    }

    :host([variant='accent']) {
      --_bg: var(--kl-accent-dim, #0d948820);
      --_color: var(--kl-accent, #0d9488);
      --_border: var(--kl-accent-border, #0d948840);
    }

    :host([variant='success']) {
      --_bg: color-mix(in srgb, var(--kl-success, #16a34a) 12%, transparent);
      --_color: var(--kl-success, #16a34a);
      --_border: color-mix(in srgb, var(--kl-success, #16a34a) 25%, transparent);
    }

    :host([variant='warning']) {
      --_bg: color-mix(in srgb, var(--kl-warning, #d97706) 12%, transparent);
      --_color: var(--kl-warning, #d97706);
      --_border: color-mix(in srgb, var(--kl-warning, #d97706) 25%, transparent);
    }

    :host([variant='error']) {
      --_bg: color-mix(in srgb, var(--kl-error, #dc2626) 12%, transparent);
      --_color: var(--kl-error, #dc2626);
      --_border: color-mix(in srgb, var(--kl-error, #dc2626) 25%, transparent);
    }

    :host([variant='neutral']) {
      --_bg: transparent;
      --_color: var(--kl-ink-tertiary, #71717a);
      --_border: var(--kl-border-strong, #d4d4d8);
    }

    .badge {
      display: inline-flex;
      align-items: center;
      gap: var(--kl-space-1, 0.25rem);
      background: var(--_bg);
      color: var(--_color);
      border: 1px solid var(--_border);
      border-radius: var(--kl-radius-full, 9999px);
      font-family: var(--kl-font-sans, 'DM Sans', system-ui, sans-serif);
      font-size: var(--kl-text-xs, 0.64rem);
      font-weight: var(--kl-weight-medium, 500);
      letter-spacing: var(--kl-tracking-label, 0.08em);
      text-transform: uppercase;
      line-height: 1;
      padding: var(--kl-space-1, 0.25rem) var(--kl-space-3, 0.75rem);
      white-space: nowrap;
    }

    :host([size='sm']) .badge {
      padding: 0.125rem var(--kl-space-2, 0.5rem);
    }
  `;
l([
  c({ type: String, reflect: !0 })
], e.prototype, "variant", 2);
l([
  c({ type: String, reflect: !0 })
], e.prototype, "size", 2);
e = l([
  g("kl-badge")
], e);
export {
  e as KlBadge
};
